import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Loads a report for the given params and reloads whenever they change.
 * A slower earlier response never overwrites a newer one.
 */
export default function useDailyReport(fetcher, params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const latest = useRef(0);
  const key = JSON.stringify(params);

  const load = useCallback(async () => {
    const requestId = ++latest.current;
    setLoading(true);
    setError(null);
    try {
      const result = await fetcher(JSON.parse(key));
      if (requestId === latest.current) setData(result);
    } catch (err) {
      if (requestId === latest.current) setError(err);
    } finally {
      if (requestId === latest.current) setLoading(false);
    }
  }, [fetcher, key]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, refetch: load };
}
